import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ArchidriveNewFolderComponent } from './archidrive-new-folder';

export const ArchidriveNewFolderModule: string = ng
    .module('archidrive-new-folder', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('archidriveNewFolderComponent', ArchidriveNewFolderComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/archidrive/archidrive-new-folder/archidrive-new-folder.module.ts